import React, { useState, useEffect } from "react";
import axios from "axios";

const SubscriptionTab = () => {
  const [callTypes, setCallTypes] = useState([]);
  const [customers, setCustomers] = useState([]);

  // Search filter states
  const [selectedCallType, setSelectedCallType] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [clientName, setClientName] = useState("");

  // Editing state
  const [editingRowId, setEditingRowId] = useState(null);  // which row is in "edit mode"
  const [editingData, setEditingData] = useState({});       // temp data for the row being edited

  const [products, setProducts] = useState([]); // ✅ State for storing available products

  const [staffMembers, setStaffMembers] = useState([]); // ✅ List of Staff Members


  useEffect(() => {
    const fetchStaffMembers = async () => {
      try {
        const response = await axios.get("https://astrovidhya.in/api/staff"); // ✅ Fetch staff from API
        setStaffMembers(response.data || []);
      } catch (error) {
        console.error("Error fetching staff members:", error);
      }
    };
    fetchStaffMembers();
  }, []);
  
  // ✅ Fetch available products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://astrovidhya.in/api/products"); // Adjust API URL if needed
        setProducts(response.data);
      } catch (err) {
        console.error("❌ Error fetching products:", err);
      }
    };
  
    fetchProducts();
  }, []);
  

  // 1. Fetch Call Types on mount
  useEffect(() => {
    const fetchCallTypes = async () => {
      try {
        const res = await axios.get("https://astrovidhya.in/api/call-types");
        setCallTypes(res.data || []);
      } catch (err) {
        console.error("Error fetching call types:", err);
      }
    };
    fetchCallTypes();
  }, []);

  // 2. Function to fetch customers based on filters
  const fetchCustomers = async () => {
    try {
      const params = {};
      if (selectedCallType.trim()) params.callType = selectedCallType;
      if (mobileNo.trim()) params.mobile = mobileNo;
      if (clientName.trim()) params.name = clientName;

      const res = await axios.get("https://astrovidhya.in/api/assigned-customers", { params });
      setCustomers(res.data);
    } catch (err) {
      console.error("Error fetching customers:", err);
    }
  };

  // 3. When user clicks "Edit", we store that row’s data in editingData
  const handleEdit = (customer) => {
    setEditingRowId(customer._id);
    setEditingData({ ...customer }); // clone the object so we can modify it
  };

  // 4. When user changes a field while editing
  const handleEditChange = (field, value) => {
    setEditingData((prev) => ({
      ...prev,
      [field]: value, // ✅ Works for both call_type & payment_method
    }));
  };
  

  // 5. "Save" -> send PUT request to server, then update state
  const handleSave = async (id) => {
    try {
      const updatedCustomer = {
        ...editingData,
        payment_method: editingData.payment_method || "", // ✅ Ensure it's included
      };
  
      await axios.put(
        `https://astrovidhya.in/api/assigned-customers/${id}`,
        updatedCustomer
      );
  
      // ✅ Update local state immediately
      setCustomers((prev) =>
        prev.map((c) => (c._id === id ? updatedCustomer : c))
      );
  
      setEditingRowId(null);
      setEditingData({});
    } catch (err) {
      console.error("❌ Error updating customer:", err);
      alert("Failed to update customer.");
    }
  };
  
  
  
  

  // 6. Cancel editing
  const handleCancel = () => {
    setEditingRowId(null);
    setEditingData({});
  };

  const handleCreateOrderFromSubscription = (cust) => {
    try {
      if (!cust || !cust.name) {
        alert("Missing required customer details.");
        return;
      }
  
      const orderData = {
        customer_name: cust.name,
        mobile: cust.mobile || "",
        shipping_address: cust.address || "",
        pin: cust.pincode || "",
        city: cust.city || "",
        state: cust.state || "",
        products: cust.products || [],
        assigned_to: cust.assignedTo || null,
        call_type: cust.callType || "NRW",
        payment_method: cust.payment_method || "", // ✅ Now correctly passed
      };
  
      console.log("🚀 Storing Order Data in localStorage:", orderData);
      localStorage.setItem("subscriptionData", JSON.stringify(orderData));
      localStorage.setItem("isSubscriptionOrder", "true");
  
      window.location.href = "/orders-management";
    } catch (error) {
      console.error("❌ Error converting subscription:", error);
      alert("Failed to convert subscription.");
    }
  };
  
  
  
  
  
  
  
  
  
  
  
  


  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-6">Subscription</h1>

      {/* === Search Filters === */}
      <div className="flex flex-wrap gap-4 mb-6">
        {/* Call Type Filter */}
        <div className="w-full md:w-1/4">
          <label className="block font-bold mb-1">Call Type</label>
          <select
            className="w-full p-2 border rounded-lg shadow-sm"
            value={selectedCallType}
            onChange={(e) => setSelectedCallType(e.target.value)}
          >
            <option value="">--Any--</option>
            {callTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
        {/* Mobile No. Filter */}
        <div className="w-full md:w-1/4">
          <label className="block font-bold mb-1">Mobile No.</label>
          <input
            type="text"
            className="w-full p-2 border rounded-lg shadow-sm"
            placeholder="Mobile no."
            maxLength={10}
            value={mobileNo}
            onChange={(e) => setMobileNo(e.target.value)}
          />
        </div>
        {/* Client Name Filter */}
        <div className="w-full md:w-1/4">
          <label className="block font-bold mb-1">Client Name</label>
          <input
            type="text"
            className="w-full p-2 border rounded-lg shadow-sm"
            placeholder="Client name"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
          />
        </div>
        {/* Search Button */}
        <div className="w-full md:w-1/5 flex items-end">
          <button
            className="w-3/4 bg-[#028CA3] text-white font-bold py-2 px-4 rounded-lg"
            onClick={fetchCustomers}
          >
            Search
          </button>
        </div>
      </div>

      {/* === Customers Table === */}
      <div className="overflow-auto">
        <table className="w-full table-auto border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 p-2">Date</th>
              <th className="border border-gray-300 p-2">Client Name</th>
              <th className="border border-gray-300 p-2">Mobile</th>
              <th className="border border-gray-300 p-2">Product</th>
              <th className="border border-gray-300 p-2">Pay Mode</th>
              <th className="border border-gray-300 p-2">Call Type</th>
              <th className="border border-gray-300 p-2">Assigned To</th>  {/* ✅ New Assigned To Column */}

              <th className="border border-gray-300 p-2">Actions</th>
<th className="border border-gray-300 p-2">Ordered</th> {/* 🆕 Added Ordered Column */}

            </tr>
          </thead>
          <tbody>
            {customers.map((cust) => {
              const isEditing = editingRowId === cust._id;
              return (
                <tr key={cust._id} className="hover:bg-gray-50">
                  {/* Date */}
                  <td className="border border-gray-300 p-2">
                    {isEditing ? (
                      <input
                        type="text"
                        className="w-full border rounded px-1"
                        value={editingData.date || ""}
                        onChange={(e) => handleEditChange("date", e.target.value)}
                      />
                    ) : (
                      cust.date || ""
                    )}
                  </td>

                  {/* Name */}
                  <td className="border border-gray-300 p-2">
                    {isEditing ? (
                      <input
                        type="text"
                        className="w-full border rounded px-1"
                        value={editingData.name || ""}
                        onChange={(e) => handleEditChange("name", e.target.value)}
                      />
                    ) : (
                      cust.name || ""
                    )}
                  </td>

           {/* Mobile */}
<td className="border border-gray-300 p-2">
  {isEditing ? (
    <input
      type="text"
      className="w-full border rounded px-1"
      value={editingData.mobile || ""}
      maxLength={10} // ✅ Added max length of 10
      onChange={(e) => {
        const input = e.target.value.replace(/\D/g, ""); // ✅ Allow only digits
        if (input.length <= 10) {
          handleEditChange("mobile", input);
        }
      }}
    />
  ) : (
    cust.mobile || ""
  )}
</td>


                  {/* Product */}
                  <td className="border border-gray-300 p-2">
  {isEditing ? (
    <div>
      {/* ✅ Multi-Select Product Dropdown */}
      <select
        multiple
        className="w-full border rounded px-1"
        value={(editingData.products || []).map((p) => p.productId)}
        onChange={(e) => {
          const selectedOptions = [...e.target.selectedOptions].map(opt => ({
            productId: opt.value,
            productName: opt.textContent,
            quantity: 1, // Default quantity
          }));

          handleEditChange("products", selectedOptions);
        }}
      >
        {products.map((product) => (
          <option key={product._id} value={product._id}>
            {product.productName}
          </option>
        ))}
      </select>

      {/* ✅ Editable Quantity Inputs for Selected Products */}
      {editingData.products?.length > 0 && (
        <div className="mt-2">
          {editingData.products.map((p, index) => (
            <div key={p.productId} className="flex items-center gap-2">
              <span>{p.productName}</span>
              <input
                type="number"
                className="w-16 border rounded px-1"
                value={p.quantity}
                min="1"
                onChange={(e) => {
                  const updatedProducts = [...editingData.products];
                  updatedProducts[index].quantity = parseInt(e.target.value, 10) || 1;
                  handleEditChange("products", updatedProducts);
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div> // ✅ Properly closed the div
  ) : (
    cust.products?.map((p) => `${p.productName} (x${p.quantity})`).join(", ") || "No products selected"
  )}
</td>



    

              {/* Pay Mode */}
<td className="border border-gray-300 p-2">
  {isEditing ? (
    <select
      className="w-full border rounded px-1"
      value={editingData.payMode || ""}
      onChange={(e) => handleEditChange("payMode", e.target.value)}
    >
      <option value="">Select Payment Method</option>
      <option value="COD">COD</option>
      <option value="Prepaid">Prepaid</option>
    </select>
  ) : (
    cust.payMode || "Not Set"
  )}
</td>




                  {/* Call Type */}
                  <td className="border border-gray-300 p-2">
                    {isEditing ? (
                      <select
                        className="w-full border rounded px-1"
                        value={editingData.callType || ""}
                        onChange={(e) => handleEditChange("callType", e.target.value)}
                      >
                        <option value="">--Select--</option>
                        {callTypes.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    ) : (
                      cust.callType || ""
                    )}
                  </td>

                 {/* Assigned To */}
<td className="border border-gray-300 p-2">
  {isEditing ? (
    <select
      className="w-full border rounded px-1"
      value={editingData.assigned_to || ""}
      onChange={(e) => handleEditChange("assigned_to", e.target.value)}
    >
      <option value="">Select Staff</option>
      {staffMembers.map((staff) => (
        <option key={staff._id} value={staff._id}>
          {staff.name}
        </option>
      ))}
    </select>
  ) : (
    cust.assigned_to
      ? staffMembers.find((s) => s._id === cust.assigned_to)?.name || "Not Assigned"
      : "Not Assigned"
  )}
</td>



                  {/* Actions */}
                  <td className="border border-gray-300 p-2 text-center">
  {isEditing ? (
    <>
      <button
        onClick={() => handleSave(cust._id)}
        className="mr-2 bg-green-500 text-white px-2 py-1 rounded"
      >
        Save
      </button>
      <button
        onClick={handleCancel}
        className="bg-gray-400 text-white px-2 py-1 rounded"
      >
        Cancel
      </button>
    </>
  ) : (
    <button
      onClick={() => handleEdit(cust)}
      className="bg-[#6b7280] text-white w-3/4 px-3 py-1 rounded mr-2"
    >
      Edit
    </button>
  )}
</td>

{/* 🆕 New "Ordered" Column */}
<td className="border border-gray-300 p-2 text-center">
  <button
    onClick={() => handleCreateOrderFromSubscription(cust)} // ✅ Convert Subscription to Order
    disabled={cust.isOrdered} // ✅ Disable if already ordered
    className={`w-3/4 px-3 py-1 rounded text-white ${
      cust.isOrdered ? "bg-gray-400 cursor-not-allowed" : "bg-[#03C9D7]"
    }`}
  >
    Ordered
  </button>
</td>


                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubscriptionTab;
